import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { BlueprintDeployment } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellLink from "ds/components/Table/Row/CellLink";
import useTypedContext from "hooks/useTypedContext";

import { TemplateContext } from "../../../Context";

const TemplateDeploymentsNameCell = ({
  item: deployment,
  ...cellProps
}: TableSimpleCellProps<BlueprintDeployment>) => {
  const { templateUrl } = useTypedContext(TemplateContext);

  return (
    <TableSimpleCell {...cellProps}>
      <TableCellLink href={`${templateUrl}/deployment/${deployment.id}`}>
        {deployment.name}
      </TableCellLink>
    </TableSimpleCell>
  );
};

export default TemplateDeploymentsNameCell;
